import { z } from "zod";

import { importPipelineInputConfigurationSchema } from "./import-pipeline-input-configuration";
import { dataMappingConfigurationSchema } from "./data-mapping-configuration";
import { ruleEngineConfigurationSchema } from "./rule-engine-configuration";

export const importPipelineConfigurationSchema = z.object({
	version: z.number(),
	initialVersion: z.number(),
	lastUpdated: z.string(),
	fileDrop: importPipelineInputConfigurationSchema,
	dataMapping: dataMappingConfigurationSchema,
	rulesConfiguration: ruleEngineConfigurationSchema,
	id: z.string().optional(),
});

export type ImportPipelineConfiguration = z.infer<typeof importPipelineConfigurationSchema>;
